import { usePartnerContext } from '@retailer-platform/dashboard/utils'
import { useGetNotificationsQuery, type NotificationSeverityEnum } from '../api'

interface UseNotificationsQueryOptions {
  severity?: NotificationSeverityEnum
  pageSize: number
  isRead?: boolean
  startDate?: string
  endDate?: string
  notifyOnNetworkStatusChange?: boolean
  pollingInterval?: number
}

export const useNotificationsQuery = (options: UseNotificationsQueryOptions) => {
  const partnerContext = usePartnerContext()

  // Create a unique key for this query based on its parameters
  const queryKey = JSON.stringify({
    severity: options.severity,
    isRead: options.isRead,
    startDate: options.startDate,
    endDate: options.endDate,
  })

  return useGetNotificationsQuery({
    variables: {
      severity: options.severity,
      partnerId: partnerContext.partnerId,
      first: options.pageSize,
      isRead: options.isRead,
      startDate: options.startDate,
      endDate: options.endDate,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
    pollInterval: options.pollingInterval,
    // Prevent Apollo from merging cached data
    context: {
      fetchOptions: {
        headers: {
          'x-query-key': queryKey,
        },
      },
    },
  })
}
